import { ArrowLeftRightIcon, TextAlignStartIcon } from "lucide-react";

import { NotificationFragment } from "@/__generated__/graphql";
import { ObjectType } from "@/objects/@types";
import { State } from "@/state";

const object: ObjectType<NotificationFragment> = {
  humanName: "notification",
  typename: "NotificationObject",
  ReactIcon: ArrowLeftRightIcon,
  isEntity: false,
  titleFieldKey: "message",
  getTitle: (data) => {
    return data?.message;
  },
  getEntityId: (data) => {
    return data?.entity?.id;
  },
  groups: [
    {
      id: "overview",
      label: "Overview",
      isVisible: true,
    },
    {
      id: "chartedAccounts",
      label: "Charted accounts",
      isVisible: (data) => data?.entityChartedAccounts?.length > 0,
    },
  ],
  fieldDefinitions: [
    {
      objectKey: "message",
      label: "Message",
      type: "text",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.message,
      getValue: (data) => {
        return data?.message;
      },
      groupId: "overview",
      updateProps: {
        isEditable: false,
      },
    },
    {
      objectKey: "entityChartedAccounts",
      label: "Charted accounts",
      type: "list",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.message,
      getValue: (data) => {
        return data?.entityChartedAccounts?.map((account) => ({
          id: account.id,
          title: account.path.slice(0, -1) + ":" + account.name,
          description: account.fullPath.join(" / "),
          createdAt: account.createdAt,
          image: account.identifier,
          onClick: () => {
            State.setState({ queuedPanelNodeIds: [data?.id] });
            State.getState().setActivePanelNodeId(account.id, {
              autofocus: false,
            });
          },
        }));
      },
      groupId: "chartedAccounts",
      updateProps: {
        isEditable: true,
      },
    },
    {
      objectKey: "isRead",
      label: "Is Read",
      type: "boolean",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.message,
      getValue: (data) => {
        return data?.isRead;
      },
      fieldProps: {
        headerFieldType: "boolean",
        isFilterable: true,
        isSortable: true,
      },
    },
    {
      objectKey: "isArchived",
      label: "Is Archived",
      type: "boolean",
      ReactIcon: TextAlignStartIcon,
      asString: (data) => data?.message,
      getValue: (data) => {
        return data?.isArchived;
      },
      fieldProps: {
        headerFieldType: "boolean",
        isFilterable: true,
        isSortable: true,
      },
    },
    {
      objectKey: "isDeleted",
      label: "Is Deleted",
      type: "boolean",
      ReactIcon: TextAlignStartIcon,
      getValue: (data) => {
        return data?.isDeleted;
      },
      asString: (data) => data?.message,
      fieldProps: {
        headerFieldType: "boolean",
        isFilterable: true,
        isSortable: true,
      },
    },
  ],
};

export { object as NotificationObject };
